import { ContextProvider } from "components/table/schedule/Context";
import { Table } from "components/table/schedule/Table";

const Scheduler = () => {
	return (
		<>
			<ContextProvider>
				<Table />
			</ContextProvider>
		</>
	);
};

export { Scheduler };
